import { IPriority } from '.';
import { ICustomIndex } from './custom-index.model';

export interface IIdentity extends IPriority, ICustomIndex {
  /** ID for the data. If omitted, a unique one will be generated. */
  id: string | number;
}
